/* istanbul ignore file */
import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { parsePercentage } from '@/common/helpers/helpers'

const CustomLabel = props => {
  const theme = useTheme()
  const { x, y, value, color } = props
  const { i18n } = useTranslation()

  const padding = 4
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  context.font = `${theme.texts.bodyXSRegular.fontSize} ${theme.texts.bodyXSRegular.fontFamily}`

  const textMetrics = context.measureText(parsePercentage(value, i18n.language) + '%')

  const textWidth = textMetrics.width
  const textHeight = textMetrics.actualBoundingBoxAscent + textMetrics.actualBoundingBoxDescent
  const rectWidth = textWidth + padding * 2
  const rectHeight = textHeight + padding * 2

  return (
    <g transform={`translate(${x - rectWidth / 2}, ${y - rectHeight / 2})`}>
      <rect x={0} y={0} width={rectWidth} height={rectHeight} fill={color} rx={4} />
      <text
        x={rectWidth / 2}
        y={10}
        fill="white"
        fontSize={theme.texts.bodyXSRegular.fontSize}
        fontFamily={theme.texts.bodyXSRegular.fontFamily}
        textAnchor="middle"
      >
        {parsePercentage(value, i18n.language)}%
      </text>
    </g>
  )
}

export default CustomLabel
